import cx from "classnames";
import PropTypes from "prop-types";
import { Component } from "react";

import CS from "metabase/css/core/index.css";
import { PLUGIN_LOGO_ICON_COMPONENTS } from "metabase/plugins";

export class DefaultLogoIcon extends Component {
  static defaultProps = {
    height: 32,
  };
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    dark: PropTypes.bool,
    fill: PropTypes.string,
  };

  render() {
    const { dark, height } = this.props;

    // Use Metabase's CSS classes for color and apply custom styles for size/weight
    return (
      <span
        className={cx(
          { [CS.textMetabaseBrand]: !dark }, // Use brand color if not dark mode
          { [CS.textWhite]: !dark ? false : true }, // Use white if dark mode
          "text-bold", // Make it bold
        )}
        style={{
          fontSize: `${Math.round(height * 0.6)}px`, // Adjust font size based on height prop
          lineHeight: `${height}px`, // Center text vertically roughly
          display: "inline-block", // Ensure proper layout
        }}
        data-testid="main-logo-text" // We used this to find the file
      >
        S.C.S
      </span>
    );
  }
}

export default function LogoIcon(props) {
  const [Component = DefaultLogoIcon] = PLUGIN_LOGO_ICON_COMPONENTS;
  return <Component {...props} />;
}
